import { IS_MAC } from "#app/lib/platform";
import { useIssueView } from "#app/components/issue-view";
import { useCanCreateProject } from "./use-can-create-project";
import { useHotkey } from "./use-hotkey";

/** Keycaps for the create-project hotkey. The Option glyph only reads right on
 *  Mac; elsewhere the key is spelled "Alt". Both name the same `altKey`. */
export const CREATE_PROJECT_SHORTCUT = IS_MAC ? ["⌥", "P"] : ["Alt", "P"];

/**
 * Workspace-wide ⌥/Alt+P opens the create-project dialog — the hotkey the
 * module-menu create popovers advertise on their Project row. Gated on the
 * same permission pair as that row, so it can never open a dialog the viewer
 * could not have reached by clicking.
 */
export function useCreateProjectHotkey(): void {
  const canCreateProject = useCanCreateProject();
  const { openCreateIssue } = useIssueView();
  useHotkey({
    code: "KeyP",
    alt: true,
    enabled: canCreateProject,
    handler: () => openCreateIssue({ source: "hotkey" }),
  });
}
